export const isWorkNestTenant = (tenantId) =>
  tenantId === process.env.REACT_APP_WORKNEST_TENANT_ID;

export default isWorkNestTenant;
